import { render, staticRenderFns } from "./Liabilities.vue?vue&type=template&id=a30a5588&scoped=true&"
import script from "./Liabilities.vue?vue&type=script&lang=js&"
export * from "./Liabilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a30a5588",
  null
  
)

export default component.exports